/**
 * @license
 * Copyright Endlessjs. All Rights Reserved.
 * Licensed under the MIT License. See License.txt in the project root for license information.
 */

import { ModuleWithProviders, NgModule } from '@angular/core';

import { ElSharedModule } from '../shared/shared.module';
import { ElOverlayModule } from '../cdk/overlay/overlay.module';
import { ElDialogService } from './dialog.service';
import { ElDialogContainerComponent } from './dialog-container';
import { EL_DIALOG_CONFIG, ElDialogConfig } from './dialog-config';


@NgModule({
  imports: [ElSharedModule, ElOverlayModule],
  declarations: [ElDialogContainerComponent],
  entryComponents: [ElDialogContainerComponent],
})
export class ElDialogModule {
  static forRoot(dialogConfig: Partial<ElDialogConfig> = {}): ModuleWithProviders {
    return {
      ngModule: ElDialogModule,
      providers: [
        ElDialogService,
        { provide: EL_DIALOG_CONFIG, useValue: dialogConfig },
      ],
    }
  }

  static forChild(dialogConfig: Partial<ElDialogConfig> = {}): ModuleWithProviders {
    return {
      ngModule: ElDialogModule,
      providers: [
        ElDialogService,
        { provide: EL_DIALOG_CONFIG, useValue: dialogConfig },
      ],
    }
  }
}
